import api from './axios'

class ServicePlan {
  async verifyPlanIsActive() {
    const { data } = await api.get("/plans/verify")
    return data
  }
}

export default new ServicePlan()